import { get, post, put, del } from '../lib/apiClient';

export const listInbox = (query) => get('/inbox', { query });

export const getMessage = (messageId) =>
  get(`/inbox/${encodeURIComponent(messageId)}`);

export const sendMessage = (payload) => post('/inbox/send', payload);

export const markRead = (messageId) =>
  put(`/inbox/${encodeURIComponent(messageId)}/read`);

export const archiveMessage = (messageId) =>
  put(`/inbox/${encodeURIComponent(messageId)}/archive`);

export const deleteMessage = (messageId) =>
  del(`/inbox/${encodeURIComponent(messageId)}`);

export const listConversations = (query) => get('/inbox/conversations', { query });

export const getConversation = (conversationId, query) =>
  get(`/inbox/conversations/${encodeURIComponent(conversationId)}`, { query });

export const getUnreadCount = () => get('/inbox/unread-count');
